import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const AccountSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.17531 9.30601C5.17531 5.53677 8.23088 2.4812 12.0001 2.4812C15.7694 2.4812 18.8249 5.53677 18.8249 9.30601C18.8249 11.7952 17.4924 13.9733 15.5013 15.1656C15.4667 15.1863 15.4475 15.2252 15.452 15.2652C15.4566 15.3052 15.4841 15.3389 15.5224 15.3513C16.2848 15.5979 17.0223 15.925 17.722 16.329C19.4617 17.3335 20.9063 18.7783 21.9105 20.5181C22.0947 20.8372 21.9854 21.2452 21.6663 21.4294C21.3472 21.6135 20.9392 21.5042 20.7551 21.1851C19.8679 19.6481 18.5917 18.3718 17.0549 17.4844C15.5446 16.6124 13.835 16.1461 12.0921 16.1302L12.0899 16.1302C12.06 16.1306 12.0301 16.1308 12.0001 16.1308C11.9701 16.1308 11.9402 16.1306 11.9103 16.1302L11.908 16.1302C10.1651 16.1461 8.45541 16.6123 6.94513 17.4844C5.40828 18.3718 4.13212 19.6481 3.24494 21.1851C3.06076 21.5042 2.65279 21.6135 2.33371 21.4294C2.01463 21.2452 1.90527 20.8372 2.08945 20.5181C3.09372 18.7783 4.53831 17.3335 6.27799 16.329C6.97773 15.925 7.71528 15.5979 8.47775 15.3512C8.51606 15.3388 8.54358 15.3052 8.54813 15.2652C8.55269 15.2252 8.53343 15.1862 8.49889 15.1655C6.50781 13.9732 5.17531 11.7952 5.17531 9.30601ZM12.0001 3.81537C8.96773 3.81537 6.50948 6.27362 6.50948 9.30601C6.50948 12.309 8.92025 14.7489 11.9121 14.796L11.9144 14.796C11.9429 14.7958 11.9715 14.7956 12 14.7956C12.0286 14.7956 12.0572 14.7958 12.0857 14.796L12.0881 14.796C15.0799 14.7489 17.4908 12.309 17.4908 9.30601C17.4908 6.27362 15.0325 3.81537 12.0001 3.81537Z"
        fill={color}
        stroke="black"
        strokeWidth="0.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { AccountSvg };
